// eslint-disable-next-line import/no-unresolved
import { ConnectKitProvider } from 'connectkit';
import { Provider } from 'react-redux';
import { SnackbarProvider } from 'notistack';
import ThemeProvider from './theme';
import { MotionLazyContainer } from './components/animate';
import Router from './routes';
import { store } from './redux/store';
import WagmiProvier from './components/wagmi/WagmiProvier';
import AuthProvider from './components/auth-provider/AuthProvider';
import ActivationDialog from './components/games/modals/activation/ActivationDialog';

function App() {
  return (
    <WagmiProvier>
      <Provider store={store}>
        <SnackbarProvider
          maxSnack={1}
          autoHideDuration={3000}
          classes={{
            containerRoot: 'snackbar-zIndex',
          }}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <AuthProvider>
            <MotionLazyContainer>
              <ThemeProvider>
                <ConnectKitProvider theme="midnight">
                  <Router />
                  <ActivationDialog />
                </ConnectKitProvider>
              </ThemeProvider>
            </MotionLazyContainer>
          </AuthProvider>
        </SnackbarProvider>
      </Provider>
    </WagmiProvier>
  );
}

export default App;
